import { GoogleOAuthProvider } from "@react-oauth/google";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { createRoot } from "react-dom/client";
import { ToastContainer } from "react-toastify";
import "semantic-ui-less/semantic.less";

import { PersistanceManager } from "components";
import ENV from "config/Env";
import { TypedQueryClientProvider } from "hooks";
import "index.scss";
import { Router } from "router";
import "utils/i18n";

// eslint-disable-next-line no-relative-import-paths/no-relative-import-paths, import/order
import "react-toastify/dist/ReactToastify.css";

const container = document.getElementById("root");

// when running on tablet screen with high density, prevent the viewport to be updated
window.addEventListener("resize", () => {
  if (document.body.clientWidth < 1440) document.querySelector("meta[name=viewport]")?.setAttribute("content", "width=1440, user-scalable=no, maximum-scale=1");
});

if (container) {
  const root = createRoot(container);
  root.render(
    <TypedQueryClientProvider>
      <ReactQueryDevtools initialIsOpen={false} />
      <GoogleOAuthProvider clientId={ENV.googleClientID || ""}>
        <ToastContainer position="top-right" autoClose={10000} closeOnClick draggable theme="light" />
        <PersistanceManager>
          <Router />
        </PersistanceManager>
      </GoogleOAuthProvider>
    </TypedQueryClientProvider>
  );
}
